import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  /* ── lost reasons ── */
  lostReasons:      ()           => api.get('/v1/lost-reasons').then(unwrap),
  createLostReason: (body)       => api.post('/v1/lost-reasons', body).then(unwrap),
  updateLostReason: (code, body) => api.patch(`/v1/lost-reasons/${code}`, body).then(unwrap),

  /* ── SLA config ── */
  slaConfig:       ()     => api.get('/v1/pipeline/sla-config').then(unwrap),
  updateSlaConfig: (body) => api.put('/v1/pipeline/sla-config', body).then(unwrap),

  /* ── assignment rules ── */
  assignmentRules:      (params)   => api.get('/v1/assignment-rules', { params }).then(unwrap),
  createAssignmentRule: (body)     => api.post('/v1/assignment-rules', body).then(unwrap),
  updateAssignmentRule: (id, body) => api.patch(`/v1/assignment-rules/${id}`, body).then(unwrap),
  deleteAssignmentRule: (id)       => api.delete(`/v1/assignment-rules/${id}`).then(unwrap),

  /* ── lead pipeline operations ── */
  // `to` is a query param on the backend; the body only carries the
  // lost-reason payload (required when to=LOST).
  updateLeadStage:  (id, to, body) =>
    api.patch(`/v1/leads/${id}/stage`, body ?? {}, { params: { to } }).then(unwrap),
  reopenLead:       (id, body) => api.post(`/v1/leads/${id}/reopen`, body).then(unwrap),
  leadDuplicates:   (id)       => api.get(`/v1/leads/${id}/duplicates`).then(unwrap),
  mergeLead:        (id, body) => api.post(`/v1/leads/${id}/merge`, body).then(unwrap),
  reassignLead:     (id, body) => api.post(`/v1/leads/${id}/reassign`, body).then(unwrap),
  leadScoreHistory: (id)       => api.get(`/v1/leads/${id}/score-history`).then(unwrap),
};
